import "./Coaches.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { BarLoader } from "react-spinners";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { InputLabel, MenuItem, Pagination, Select } from "@mui/material";
import { Box } from "@mui/material";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { BaseURL } from "../../../Hooks/URL";
import FormControl from "@mui/material/FormControl";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "name",
    label: "Team Name",
    minWidth: 100,
  },
  {
    id: "contactNumber",
    label: "Phone Number",
    minWidth: 100,
  },
  {
    id: "account",
    label: "Account ID",
    minWidth: 100,
  },
  {
    id: "teams",
    label: "Teams",
    minWidth: 100,
  },
];

function Coaches({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  coaches,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  coachesNumber,
  setPage,
  getFilterQueryString,
  filters,
  handleFilterChange,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showFilters, setShowFilters] = useState(!isMobile);

  return (
    <div className="mainContainer">
      <div className="cont">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Total Coaches: {coachesNumber}</h2>
          <a
            href={`${BaseURL}/admin/dashboard/coaches/excel?${
              search ? `&search=${search}` : ""
            }&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`}
            target="_blank"
          >
            <PrimaryButton
              classBtn={"center editButton"}
              text={"Download Excel"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--text-primary)",
                height: "40px",
                padding: "0 30px",
                fontSize: "15px",
              }}
            />
          </a>
        </Box>

        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {isMobile && (
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                backgroundColor: "var(--primary)",
                color: "white",
                "&:hover": {
                  backgroundColor: "#8a0505",
                },
              }}
            >
              <FilterListIcon />
            </IconButton>
          )}
        </Box>

        <Collapse in={showFilters}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Search"}
                className="SearchBar"
                name={"search"}
                change={(e) => setSearchData(e.target.value)}
                newValue={searchData}
                searchAction={() => {
                  if (search != searchData) {
                    setSearch(searchData);
                    setPage(0);
                  }
                }}
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    if (search != searchData) {
                      setSearch(searchData);
                      setPage(0);
                    }
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Account Paid</InputLabel>
                <Select
                  value={filters?.accountPaid}
                  label="Account Paid"
                  name="accountPaid"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Competition Type</InputLabel>
                <Select
                  value={filters?.competitionType}
                  label="Competition Type"
                  name="competitionType"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                  <MenuItem value="onlineOnly">Online Only</MenuItem>
                  <MenuItem value="offline">Offline</MenuItem>
                  <MenuItem value="offlineOnly">Offline Only</MenuItem>
                  <MenuItem value="both">Both</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
          </Grid>
        </Collapse>

        <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {coaches && !loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {coaches?.map((coach, i) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={coach.id}
                          style={{ cursor: "pointer" }}
                        >
                          {columns.map((column) => {
                            const value = coach[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id == "teams" ? (
                                  value?.map((team) => (
                                    <span
                                      style={{ textDecoration: "underline" }}
                                      onClick={() =>
                                        navigate(`/teams/${team?.id}`)
                                      }
                                    >
                                      {team?.name},{" "}
                                    </span>
                                  ))
                                ) : column.id == "account" ? (
                                  <span
                                    style={{ textDecoration: "underline" }}
                                    onClick={() =>
                                      navigate(`/accounts/${value?.id}`)
                                    }
                                  >
                                    {value?.code}
                                  </span>
                                ) : (
                                  value ?? "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!coaches?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No Coaches Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0 20px`",
                  padding: "20px",
                  color: "var(--primary)",
                  "& .Mui-selected": {
                    backgroundColor: "var(--primary)",
                    color: "white",
                  },
                }}
              />
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default Coaches;
